import { c as _c } from "react/compiler-runtime";
import type { CountdownData } from "@/hooks/useMintCountdownState";
import { formatCountdownVerbose } from "@/utils/timeFormatters";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { memo, useEffect, useRef, useState } from "react";
interface NowMintingCountdownActiveProps {
  readonly countdown: CountdownData;
}
export default function NowMintingCountdownActive(t0) {
  const $ = _c(15);
  const {
    countdown
  } = t0;
  let t1;
  if ($[0] !== countdown.title) {
    t1 = <span className="tw-text-xs tw-font-semibold tw-text-iron-300">{countdown.title}</span>;
    $[0] = countdown.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== countdown.isActive) {
    t2 = countdown.isActive && <div className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-success/20 tw-bg-success/10 tw-px-2 tw-py-0.5"><span className="tw-relative tw-flex tw-h-2 tw-w-2"><span className="tw-absolute tw-inline-flex tw-h-full tw-w-full tw-animate-ping tw-rounded-full tw-bg-success/60" /><span className="tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-success" /></span><span className="tw-text-[10px] tw-font-semibold tw-text-success/80">Live</span></div>;
    $[2] = countdown.isActive;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== countdown.targetDate) {
    t4 = <div className="tw-mb-3 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-white/5 tw-bg-iron-950/80 tw-p-3 tw-shadow-[inset_0_1px_2px_rgba(0,0,0,0.5)]"><div className="tw-text-xl tw-font-bold tw-tabular-nums tw-text-iron-50 md:tw-text-2xl"><LiveCountdown targetTimestampSeconds={countdown.targetDate} /></div></div>;
    $[7] = countdown.targetDate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== countdown.showMintBtn) {
    t5 = countdown.showMintBtn && <Link href="/the-memes/mint" className="tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-gap-x-1.5 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-bg-iron-200 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-950 tw-no-underline tw-ring-1 tw-ring-inset tw-ring-white tw-transition tw-duration-300 tw-ease-out focus:tw-z-10 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset desktop-hover:hover:tw-bg-iron-300 desktop-hover:hover:tw-text-iron-950 desktop-hover:hover:tw-ring-iron-300">Mint<ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" strokeWidth={2} /></Link>;
    $[9] = countdown.showMintBtn;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900/40 tw-p-3 tw-text-left md:tw-p-4">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
const LiveCountdown = memo(t0 => {
  const $ = _c(7);
  const {
    targetTimestampSeconds
  } = t0;
  let t1;
  if ($[0] !== targetTimestampSeconds) {
    t1 = () => formatCountdownVerbose(targetTimestampSeconds);
    $[0] = targetTimestampSeconds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [display, setDisplay] = useState(t1);
  const timerRef = useRef(null);
  let t2;
  let t3;
  if ($[2] !== targetTimestampSeconds) {
    t2 = () => {
      const targetMs = targetTimestampSeconds * 1000;
      const tick = () => {
        setDisplay(formatCountdownVerbose(targetTimestampSeconds));
        if (Date.now() >= targetMs) {
          return;
        }
        const now = Date.now();
        const msUntilNextSecond = 1000 - now % 1000;
        timerRef.current = setTimeout(tick, msUntilNextSecond);
      };
      tick();
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = null;
      };
    };
    t3 = [targetTimestampSeconds];
    $[2] = targetTimestampSeconds;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== display) {
    t4 = <span>{display}</span>;
    $[5] = display;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});
LiveCountdown.displayName = "LiveCountdown";